import React from 'react';
import { motion } from 'framer-motion';
export function Comparison() {
  const rows = [{
    a: 'Rutinas que no encajan',
    b: 'Tiempo perdido + abandono'
  }, {
    a: 'Membresía de gimnasio',
    b: '$15.000/mes que no usás'
  }, {
    a: 'Planes sin mantenimiento',
    b: 'Rebote garantizado'
  }, {
    a: 'El mismo ciclo de siempre',
    b: 'El mismo lunes, el año que viene'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-51" data-mp="1uwxje8nrf3cj">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-52" data-mp="1zuz571cklgrp">
        ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-brand-card border border-brand-green/20 rounded-2xl overflow-hidden mb-12" data-id="element-53" data-mp="9m8l6jcz884p">
        <div className="grid grid-cols-2 bg-brand-darker border-b border-brand-green/20" data-id="element-54" data-mp="1d85jbr7ck523">
          <div className="p-4 md:p-6 font-bold text-gray-400 text-center md:text-left" data-id="element-55" data-mp="189aplu7ucw37">
            Sin SuperPack
          </div>
          <div className="p-4 md:p-6 font-bold text-brand-green text-center md:text-left border-l border-brand-green/20" data-id="element-56" data-mp="24yjtbcc8ox8h">
            Costo Real
          </div>
        </div>

        <div className="divide-y divide-brand-green/10" data-id="element-57" data-mp="1vymzkwazt86k">
          {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-brand-green/5 transition-colors" data-id="element-58" data-mp="1r029hppgg4vu" data-mpi={i}>
              <div className="p-4 md:p-6 text-gray-300 text-sm md:text-base" data-id="element-59" data-mp="kkj6dsc8bo2k">
                {row.a}
              </div>
              <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base border-l border-brand-green/10" data-id="element-60" data-mp="fjbx1oufugts">
                {row.b}
              </div>
            </div>)}
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="text-center" data-id="element-61" data-mp="lyj62jt5px2p">
        <h3 className="text-3xl md:text-5xl font-black" data-id="element-62" data-mp="3uf5lxek4avrv">
          El próximo lunes{' '}
          <span className="text-brand-green" data-id="element-63" data-mp="32t3ovhbayoa">puede ser diferente.</span>
        </h3>
      </motion.div>
    </section>;
}